// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.EvaluationCard-module__container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 20px;
  width: 100%;
  max-width: 428px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 4px 77px 0px rgba(0, 0, 0, 0.05);
}

.EvaluationCard-module__header {
  display: flex;
  flex-direction: row;
  gap: 24px;
}

.EvaluationCard-module__title {
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
  color: #14142b;
}

.EvaluationCard-module__divider {
  width: 100%;
  height: 1px;
  background-color: #d9dbe9;
}

/* L1 Evaluation Card */

.EvaluationCard-module__l1Card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background-color: #eae8ff;
  border: 1px solid #aaa3f7;
  border-radius: 12px;
}

.EvaluationCard-module__l1CardAccepted {
}

.EvaluationCard-module__l1CardGrey {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background-color: #ededed;
  border: 1px solid #919191;
  border-radius: 12px;
}

.EvaluationCard-module__scrutinyText {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #4e4b66;
}

.EvaluationCard-module__cardHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.EvaluationCard-module__labelRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.EvaluationCard-module__yellowDot {
  width: 12px;
  height: 12px;
  background-color: #ffcd2a;
  border-radius: 50%;
  flex-shrink: 0;
}

.EvaluationCard-module__cardTitle {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #19107c;
}

.EvaluationCard-module__cardTitleGrey {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #46445b;
}

.EvaluationCard-module__acceptedBadge {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 4px 10px;
  background-color: #73b269;
  border-radius: 12px;
}

.EvaluationCard-module__acceptedBadgeText {
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #ffffff;
}

.EvaluationCard-module__acceptedBadgeIcon {
  width: 16px;
  height: 16px;
}

.EvaluationCard-module__score {
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  color: #14142b;
}

.EvaluationCard-module__feedbackContainer {
  display: flex;
  flex-direction: column;
}

.EvaluationCard-module__feedbackText {
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #4e4b66;
}

.EvaluationCard-module__feedbackTextTruncated {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.EvaluationCard-module__readMore {
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: #3c8dcb;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  text-align: right;
}

.EvaluationCard-module__readMore:hover {
  text-decoration: underline;
}

.EvaluationCard-module__buttonRow {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.EvaluationCard-module__acceptButton {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #00354e;
  border: 1px solid rgba(38, 54, 67, 0.3);
  border-radius: 70px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.EvaluationCard-module__acceptButton:hover:not(:disabled) {
  transform: translateY(-2px);
}

.EvaluationCard-module__acceptButton:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.EvaluationCard-module__acceptButtonText {
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.08em;
  color: #ffffff;
  text-transform: uppercase;
}

.EvaluationCard-module__overrideButton {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 150px;
  gap: 8px;
  padding: 8px 12px;
  background-color: #f3faff;
  border: 1px solid rgba(38, 54, 67, 0.3);
  border-radius: 70px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.EvaluationCard-module__overrideButton:hover {
  transform: translateY(-2px);
}

.EvaluationCard-module__overrideButtonIcon {
  width: 16px;
  height: 16px;
}

.EvaluationCard-module__overrideButtonText {
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.08em;
  color: #263643;
  text-transform: uppercase;
}

/* SME Evaluation Form */

.EvaluationCard-module__smeCard {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background-color: #fffdf3;
  border: 1px solid #c4a200;
  border-radius: 12px;
}

.EvaluationCard-module__smeHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.EvaluationCard-module__smeTitle {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #533701;
}

.EvaluationCard-module__cancelButton {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  padding: 8px 12px;
  background-color: #f3faff;
  border: 1px solid rgba(38, 54, 67, 0.3);
  border-radius: 70px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.EvaluationCard-module__cancelButton:hover {
  background-color: #d8edfe;
  transform: translateY(-2px);
}

.EvaluationCard-module__cancelButtonText {
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.08em;
  color: #263643;
  text-transform: uppercase;
}

.EvaluationCard-module__formContainer {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.EvaluationCard-module__marksSection {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.EvaluationCard-module__marksInputRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.EvaluationCard-module__marksInput {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 20px;
  width: 85px;
  background-color: #ffffff;
  border: 1px solid #c4a200;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #14142b;
  text-align: center;
}

.EvaluationCard-module__marksInput::placeholder {
  color: #6e7191;
}

.EvaluationCard-module__marksInput:focus {
  outline: none;
  border-color: #a08300;
}

.EvaluationCard-module__marksInputError {
  border-color: #e53935;
}

.EvaluationCard-module__marksInputReadOnly {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.EvaluationCard-module__maxMarks {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #14142b;
}

.EvaluationCard-module__helperText {
  font-weight: 500;
  font-size: 12px;
  line-height: 2em;
  color: #4e4b66;
}

.EvaluationCard-module__errorText {
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #e53935;
}

.EvaluationCard-module__remarksSection {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.EvaluationCard-module__remarksLabel {
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  color: #7c7c7c;
}

.EvaluationCard-module__remarksTextarea {
  width: 100%;
  min-height: 87px;
  padding: 10px 14px;
  background-color: #ffffff;
  border: 1px solid #bcbcbc;
  border-radius: 5px;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  color: #4e4b66;
  resize: vertical;
}

.EvaluationCard-module__remarksTextarea::placeholder {
  color: rgba(124, 124, 124, 0.7);
}

.EvaluationCard-module__remarksTextarea:focus {
  outline: none;
  border-color: #c4a200;
}

.EvaluationCard-module__remarksTextareaError {
  border-color: #e53935;
}

.EvaluationCard-module__remarksTextareaReadOnly {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* Student Challenge Card */

.EvaluationCard-module__studentChallengeCard {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background-color: rgba(159, 214, 255, 0.2);
  border: 1px solid #9fd6ff;
  border-radius: 12px;
}

.EvaluationCard-module__studentChallengeTitle {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #074473;
}

.EvaluationCard-module__revisedEvaluationTitle {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #533701;
}

/* Content Section */

.EvaluationCard-module__contentSection {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.EvaluationCard-module__sectionsWrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.EvaluationCard-module__badgeGreyed{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
  font-size: 11px;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  background-color: #808080;
  color: #ffffff;
}

.EvaluationCard-module__evaluationResultBadge{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
  font-size: 11px;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.EvaluationCard-module__badgeHolder{
  display:flex;
  flex-direction: column;
  gap:4px;
}

.EvaluationCard-module__attempStatusStyle {
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  color: #7c7c7c;
}

.EvaluationCard-module__attempStatusStyle select {
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  color: #7c7c7c;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 8px;
  background-color: #ffffff;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s ease;
}

.EvaluationCard-module__attempStatusStyle select:hover {
  border-color: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./src/components/evaluation/EvaluationCard.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EAEE,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* Container */\n.container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 32px 20px;\n  width: 100%;\n  max-width: 428px;\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0px 4px 77px 0px rgba(0, 0, 0, 0.05);\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n}\n\n.title {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 100%;\n  color: #14142b;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: #d9dbe9;\n}\n\n/* L1 Evaluation Card */\n\n.l1Card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  background-color: #eae8ff;\n  border: 1px solid #aaa3f7;\n  border-radius: 12px;\n}\n\n.l1CardAccepted {\n  composes: l1Card;\n}\n\n.l1CardGrey {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  background-color: #ededed;\n  border: 1px solid #919191;\n  border-radius: 12px;\n}\n\n.scrutinyText {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #4e4b66;\n}\n\n.cardHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.labelRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.yellowDot {\n  width: 12px;\n  height: 12px;\n  background-color: #ffcd2a;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.cardTitle {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #19107c;\n}\n\n.cardTitleGrey {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #46445b;\n}\n\n.acceptedBadge {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 10px;\n  background-color: #73b269;\n  border-radius: 12px;\n}\n\n.acceptedBadgeText {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 150%;\n  color: #ffffff;\n}\n\n.acceptedBadgeIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.score {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 18px;\n  color: #14142b;\n}\n\n.feedbackContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.feedbackText {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  color: #4e4b66;\n}\n\n.feedbackTextTruncated {\n  composes: feedbackText;\n  display: -webkit-box;\n  line-clamp: 2;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.readMore {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  color: #3c8dcb;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  text-align: right;\n}\n\n.readMore:hover {\n  text-decoration: underline;\n}\n\n.buttonRow {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n}\n\n.acceptButton {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background-color: #00354e;\n  border: 1px solid rgba(38, 54, 67, 0.3);\n  border-radius: 70px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.acceptButton:hover:not(:disabled) {\n  transform: translateY(-2px);\n}\n\n.acceptButton:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.acceptButtonText {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0.08em;\n  color: #ffffff;\n  text-transform: uppercase;\n}\n\n.overrideButton {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 150px;\n  gap: 8px;\n  padding: 8px 12px;\n  background-color: #f3faff;\n  border: 1px solid rgba(38, 54, 67, 0.3);\n  border-radius: 70px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.overrideButton:hover {\n  transform: translateY(-2px);\n}\n\n.overrideButtonIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.overrideButtonText {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0.08em;\n  color: #263643;\n  text-transform: uppercase;\n}\n\n/* SME Evaluation Form */\n\n.smeCard {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  background-color: #fffdf3;\n  border: 1px solid #c4a200;\n  border-radius: 12px;\n}\n\n.smeHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.smeTitle {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #533701;\n}\n\n.cancelButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  padding: 8px 12px;\n  background-color: #f3faff;\n  border: 1px solid rgba(38, 54, 67, 0.3);\n  border-radius: 70px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cancelButton:hover {\n  background-color: #d8edfe;\n  transform: translateY(-2px);\n}\n\n.cancelButtonText {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0.08em;\n  color: #263643;\n  text-transform: uppercase;\n}\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.marksSection {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.marksInputRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.marksInput {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 20px;\n  width: 85px;\n  background-color: #ffffff;\n  border: 1px solid #c4a200;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #14142b;\n  text-align: center;\n}\n\n.marksInput::placeholder {\n  color: #6e7191;\n}\n\n.marksInput:focus {\n  outline: none;\n  border-color: #a08300;\n}\n\n.marksInputError {\n  composes: marksInput;\n  border-color: #e53935;\n}\n\n.marksInputReadOnly {\n  composes: marksInput;\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.maxMarks {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #14142b;\n}\n\n.helperText {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 2em;\n  color: #4e4b66;\n}\n\n.errorText {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 150%;\n  color: #e53935;\n}\n\n.remarksSection {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.remarksLabel {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 100%;\n  color: #7c7c7c;\n}\n\n.remarksTextarea {\n  width: 100%;\n  min-height: 87px;\n  padding: 10px 14px;\n  background-color: #ffffff;\n  border: 1px solid #bcbcbc;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 100%;\n  color: #4e4b66;\n  resize: vertical;\n}\n\n.remarksTextarea::placeholder {\n  color: rgba(124, 124, 124, 0.7);\n}\n\n.remarksTextarea:focus {\n  outline: none;\n  border-color: #c4a200;\n}\n\n.remarksTextareaError {\n  composes: remarksTextarea;\n  border-color: #e53935;\n}\n\n.remarksTextareaReadOnly {\n  composes: remarksTextarea;\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n/* Student Challenge Card */\n\n.studentChallengeCard {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  background-color: rgba(159, 214, 255, 0.2);\n  border: 1px solid #9fd6ff;\n  border-radius: 12px;\n}\n\n.studentChallengeTitle {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #074473;\n}\n\n.revisedEvaluationTitle {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #533701;\n}\n\n/* Content Section */\n\n.contentSection {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sectionsWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.badgeGreyed{\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 1;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n  background-color: #808080;\n  color: #ffffff;\n}\n\n.evaluationResultBadge{\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 1;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.badgeHolder{\n  display:flex;\n  flex-direction: column;\n  gap:4px;\n}\n\n.attempStatusStyle {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 100%;\n  color: #7c7c7c;\n}\n\n.attempStatusStyle select {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 100%;\n  color: #7c7c7c;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 8px 8px;\n  background-color: #ffffff;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.attempStatusStyle select:hover {\n  border-color: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EvaluationCard-module__container`,
	"header": `EvaluationCard-module__header`,
	"title": `EvaluationCard-module__title`,
	"divider": `EvaluationCard-module__divider`,
	"l1Card": `EvaluationCard-module__l1Card`,
	"l1CardAccepted": `EvaluationCard-module__l1CardAccepted EvaluationCard-module__l1Card`,
	"l1CardGrey": `EvaluationCard-module__l1CardGrey`,
	"scrutinyText": `EvaluationCard-module__scrutinyText`,
	"cardHeader": `EvaluationCard-module__cardHeader`,
	"labelRow": `EvaluationCard-module__labelRow`,
	"yellowDot": `EvaluationCard-module__yellowDot`,
	"cardTitle": `EvaluationCard-module__cardTitle`,
	"cardTitleGrey": `EvaluationCard-module__cardTitleGrey`,
	"acceptedBadge": `EvaluationCard-module__acceptedBadge`,
	"acceptedBadgeText": `EvaluationCard-module__acceptedBadgeText`,
	"acceptedBadgeIcon": `EvaluationCard-module__acceptedBadgeIcon`,
	"score": `EvaluationCard-module__score`,
	"feedbackContainer": `EvaluationCard-module__feedbackContainer`,
	"feedbackText": `EvaluationCard-module__feedbackText`,
	"feedbackTextTruncated": `EvaluationCard-module__feedbackTextTruncated EvaluationCard-module__feedbackText`,
	"readMore": `EvaluationCard-module__readMore`,
	"buttonRow": `EvaluationCard-module__buttonRow`,
	"acceptButton": `EvaluationCard-module__acceptButton`,
	"acceptButtonText": `EvaluationCard-module__acceptButtonText`,
	"overrideButton": `EvaluationCard-module__overrideButton`,
	"overrideButtonIcon": `EvaluationCard-module__overrideButtonIcon`,
	"overrideButtonText": `EvaluationCard-module__overrideButtonText`,
	"smeCard": `EvaluationCard-module__smeCard`,
	"smeHeader": `EvaluationCard-module__smeHeader`,
	"smeTitle": `EvaluationCard-module__smeTitle`,
	"cancelButton": `EvaluationCard-module__cancelButton`,
	"cancelButtonText": `EvaluationCard-module__cancelButtonText`,
	"formContainer": `EvaluationCard-module__formContainer`,
	"marksSection": `EvaluationCard-module__marksSection`,
	"marksInputRow": `EvaluationCard-module__marksInputRow`,
	"marksInput": `EvaluationCard-module__marksInput`,
	"marksInputError": `EvaluationCard-module__marksInputError EvaluationCard-module__marksInput`,
	"marksInputReadOnly": `EvaluationCard-module__marksInputReadOnly EvaluationCard-module__marksInput`,
	"maxMarks": `EvaluationCard-module__maxMarks`,
	"helperText": `EvaluationCard-module__helperText`,
	"errorText": `EvaluationCard-module__errorText`,
	"remarksSection": `EvaluationCard-module__remarksSection`,
	"remarksLabel": `EvaluationCard-module__remarksLabel`,
	"remarksTextarea": `EvaluationCard-module__remarksTextarea`,
	"remarksTextareaError": `EvaluationCard-module__remarksTextareaError EvaluationCard-module__remarksTextarea`,
	"remarksTextareaReadOnly": `EvaluationCard-module__remarksTextareaReadOnly EvaluationCard-module__remarksTextarea`,
	"studentChallengeCard": `EvaluationCard-module__studentChallengeCard`,
	"studentChallengeTitle": `EvaluationCard-module__studentChallengeTitle`,
	"revisedEvaluationTitle": `EvaluationCard-module__revisedEvaluationTitle`,
	"contentSection": `EvaluationCard-module__contentSection`,
	"sectionsWrapper": `EvaluationCard-module__sectionsWrapper`,
	"badgeGreyed": `EvaluationCard-module__badgeGreyed`,
	"evaluationResultBadge": `EvaluationCard-module__evaluationResultBadge`,
	"badgeHolder": `EvaluationCard-module__badgeHolder`,
	"attempStatusStyle": `EvaluationCard-module__attempStatusStyle`
};
export default ___CSS_LOADER_EXPORT___;
